import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form } from 'semantic-ui-react'

import { EVENT_TYPES, EventType } from 'sports'
import { SimpleButton } from 'ui'

import { actions, selectors } from '../redux'

import type { FC } from 'react'

import type { TournamentSchema } from '../schemas/TournamentSchema'

export interface ReportsScreenProps {
  tournament: TournamentSchema
}

export interface ReportSchema {
  id: string
  event: boolean
  events: EventType[]
  match: boolean
  player: boolean
  round: boolean
  stage: boolean
  stages: string[]
  sum: boolean
  team: boolean
}

const ReportsScreen: FC<ReportsScreenProps> = ({ tournament }) => {
  const dispatch = useDispatch()
  const { loading } = useSelector(selectors.reports.report)

  const { handleSubmit, register, setValue } = useForm({
    defaultValues: {
      id: tournament.id,
      event: true,
      events: Object.values(EventType).filter((type) => type.includes('CARD')),
      match: true,
      player: true,
      round: true,
      stage: true,
      stages: tournament.tournament.stages.map(({ id }) => id),
      sum: true,
      team: true,
    } as ReportSchema,
  })

  const onSubmit = (values: ReportSchema) => {
    dispatch(actions.reportFetch(values))
  }

  const setGoalTypes = () => {
    setValue('events', [
      ...Object.values(EventType).filter((type) => type.includes('GOAL')),
      EventType.PENAL_DEFINITION,
    ])
  }

  const setCardTypes = () => {
    setValue(
      'events',
      Object.values(EventType).filter((type) => type.includes('CARD')),
    )
  }

  return (
    <div className="bg-white p-2">
      <div className="text-lg font-bold py-2">Generar reporte</div>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="pb-1 pt-2 font-bold">Incluir las siguientes columnas:</div>
        <div className="flex flex-wrap border-y *:!m-0 *:whitespace-nowrap p-1 gap-1">
          <Form.Input className="flex flex-col" label="" readOnly={loading}>
            <label>
              <span>
                <input className="!w-10 !max-w-10" {...register('player')} type="checkbox" />
              </span>
              Jugador
            </label>
          </Form.Input>
          <Form.Input className="flex flex-col" label="" readOnly={loading}>
            <label>
              <span>
                <input className="!w-10 !max-w-10" {...register('team')} type="checkbox" />
              </span>
              Equipo
            </label>
          </Form.Input>
          <Form.Input className="flex flex-col" label="" readOnly={loading}>
            <label>
              <span>
                <input className="!w-10 !max-w-10" {...register('stage')} type="checkbox" />
              </span>
              Fase
            </label>
          </Form.Input>
          <Form.Input className="flex flex-col" label="" readOnly={loading}>
            <label>
              <span>
                <input className="!w-10 !max-w-10" {...register('round')} type="checkbox" />
              </span>
              Ronda <small>(Fecha)</small>
            </label>
          </Form.Input>
          <Form.Input className="flex flex-col" label="" readOnly={loading}>
            <label>
              <span>
                <input className="!w-10 !max-w-10" {...register('match')} type="checkbox" />
              </span>
              Encuentro <small>(día y hora)</small>
            </label>
          </Form.Input>
          <Form.Input className="flex flex-col" label="" readOnly={loading}>
            <label>
              <span>
                <input className="!w-10 !max-w-10" {...register('event')} type="checkbox" />
              </span>
              Tipo de evento
            </label>
          </Form.Input>
        </div>
        <div className="pb-1 pt-2 font-bold">Incluir las fases:</div>
        <div className="flex flex-wrap border-y *:!m-0 *:whitespace-nowrap p-1 gap-1">
          {tournament.tournament.stages.map(({ id, name }) => (
            <Form.Input key={id} className="flex flex-col" label="" readOnly={loading}>
              <label>
                <span>
                  <input className="!w-10 !max-w-10" {...register('stages')} type="checkbox" value={id} />
                </span>
                {name}
              </label>
            </Form.Input>
          ))}
        </div>
        <div className="pb-1 pt-2 font-bold">
          Incluir los tipos de evento:{' '}
          <SimpleButton className="text-xs" onClick={setGoalTypes} tertiary value="Goles" />
          <SimpleButton className="text-xs" onClick={setCardTypes} tertiary value="Tarjetas" />
        </div>
        <div className="flex flex-wrap border-y *:!m-0 *:whitespace-nowrap p-1 gap-1">
          {Object.entries(EVENT_TYPES)
            .sort(([, { name: a }], [, { name: b }]) => a.localeCompare(b))
            .map(([type, { name }]) => (
              <Form.Input key={type} className="flex flex-col" label="" readOnly={loading}>
                <label>
                  <span>
                    <input className="!w-10 !max-w-10" {...register('events')} type="checkbox" value={type} />
                  </span>
                  {name}
                </label>
              </Form.Input>
            ))}
        </div>
        <div className="pt-2 border-t">
          <Button
            content={loading ? 'Generando...' : 'Descargar'}
            icon={loading ? 'spinner' : 'download'}
            primary
            readOnly={loading}
            type="submit"
          />
        </div>
      </Form>
    </div>
  )
}

export default ReportsScreen
